import { render, staticRenderFns } from "./CreateGroupSurveyEmailSettings.vue?vue&type=template&id=0c4d22f9&scoped=true"
import script from "./CreateGroupSurveyEmailSettings.vue?vue&type=script&lang=js"
export * from "./CreateGroupSurveyEmailSettings.vue?vue&type=script&lang=js"
import style0 from "./CreateGroupSurveyEmailSettings.vue?vue&type=style&index=0&id=0c4d22f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4d22f9",
  null
  
)

export default component.exports